export default {"src":"/_next/static/media/ZM.a4e2d3cf.svg","height":18,"width":18};